import {
  AMT_2025_TRAN_AMT_WHITE_LIST,
  GROCERY_FAV_ITEM_BLACK_LIST,
  HUGE_VALIDATION_VALUE_THRESHOLD,
  MAX_STATISTIC_ITEM_FLOAT_VALUE_SIGNS_AFTER_COMMA,
  MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
  MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
  ONE_HOUR_IN_SECONDS,
  ONE_MINUTE_IN_SECONDS,
  PETS_FAV_ITEM_BLACK_LIST,
  SECONDS_VALIDATION_MULTIPLIER,
  TFOOD_FAV_ITEM_BLACK_LIST,
} from '@/constants';
import {NamedValidationConfig} from '@/resources/index';
import {StatisticItemValidationType} from '@/types';

// при добавлении конфига статистики сначала нужно указывать валидирующие правила, такие как:
// MinStringLength, BlackListString, MoreThanValueNumber, LessThanValueNumber;
// а затем добавлять остальные, которые также еще и трансформируют значение

export const statisticValidationConfig: NamedValidationConfig[] = [
  {
    name: 'clothes_spend_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: HUGE_VALIDATION_VALUE_THRESHOLD,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'clothes_fav_brand',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'food_spend_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: HUGE_VALIDATION_VALUE_THRESHOLD,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'food_fav_brand',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'pets_spend_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: HUGE_VALIDATION_VALUE_THRESHOLD,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'pets_fav_item',
    rules: [
      {
        name: StatisticItemValidationType.BlackListString,
        value: PETS_FAV_ITEM_BLACK_LIST,
      },
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'beauty_spend_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: HUGE_VALIDATION_VALUE_THRESHOLD,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'beauty_fav_brand',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'avia_spend_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: HUGE_VALIDATION_VALUE_THRESHOLD,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'transport_spend_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: HUGE_VALIDATION_VALUE_THRESHOLD,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'transport_fav_kind',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'grocery_spend_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: HUGE_VALIDATION_VALUE_THRESHOLD,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'grocery_fav_brand',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'grocery_fav_item',
    rules: [
      {
        name: StatisticItemValidationType.BlackListString,
        value: GROCERY_FAV_ITEM_BLACK_LIST,
      },
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'mp_spend_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: HUGE_VALIDATION_VALUE_THRESHOLD,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'mp_fav_brand',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'home_spend_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: HUGE_VALIDATION_VALUE_THRESHOLD,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'zodiac_sign',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'min_spend_tran_amt_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 0,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'min_spend_tran_brand',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'min_spend_tran_date',
    rules: [
      {
        name: StatisticItemValidationType.DayMonthDate,
        value: true,
      },
    ],
  },
  {
    name: 'max_cnt_tran_dt',
    rules: [
      {
        name: StatisticItemValidationType.DayMonthDate,
        value: true,
      },
    ],
  },
  {
    name: 'max_cnt_tran_cnt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 2,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'frac_onl_tran',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 0,
      },
      {
        name: StatisticItemValidationType.LessThanValue,
        value: 100,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'charity_spend_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 499,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'data_gb',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 228,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'cnt_call',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 0,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'max_call_len_sec',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: ONE_MINUTE_IN_SECONDS,
      },
      {
        name: StatisticItemValidationType.Seconds,
        value: ONE_MINUTE_IN_SECONDS,
      },
    ],
  },
  {
    name: 'seconds_in_air',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: ONE_HOUR_IN_SECONDS,
      },
      {
        name: StatisticItemValidationType.Seconds,
        value: ONE_HOUR_IN_SECONDS,
      },
    ],
  },
  {
    name: 'afisha_event_cnt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 0,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'fuel_order_cnt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 0,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'wordle_correct_cnt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 4,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'top_1_spend_tran_amt_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: HUGE_VALIDATION_VALUE_THRESHOLD,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'top_2_spend_tran_amt_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: HUGE_VALIDATION_VALUE_THRESHOLD,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'top_3_spend_tran_amt_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: HUGE_VALIDATION_VALUE_THRESHOLD,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'top_1_spend_tran_brand',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'top_2_spend_tran_brand',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'top_3_spend_tran_brand',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'frac_night_tran',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 0,
      },
      {
        name: StatisticItemValidationType.LessThanValue,
        value: 100,
      },
      {
        name: StatisticItemValidationType.SignsAfterComma,
        value: MAX_STATISTIC_ITEM_FLOAT_VALUE_SIGNS_AFTER_COMMA,
      },
    ],
  },
  {
    name: 'cnt_region',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 1,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'mb_sec',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: SECONDS_VALIDATION_MULTIPLIER * ONE_MINUTE_IN_SECONDS,
      },
      {
        name: StatisticItemValidationType.Seconds,
        value: ONE_MINUTE_IN_SECONDS,
      },
    ],
  },
  {
    name: 'amt_2025_tran_dt',
    rules: [
      {
        name: StatisticItemValidationType.DayMonthDate,
        value: true,
      },
    ],
  },
  {
    name: 'amt_2025_tran_amt',
    rules: [
      {
        name: StatisticItemValidationType.WhiteListNumber,
        value: AMT_2025_TRAN_AMT_WHITE_LIST,
      },
    ],
  },
  {
    name: 'jun_oleg_msg_cnt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 2,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'best_combo_nm',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: 2 * MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'best_combo_cat',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: 2 * MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'sum_sav_perc_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 999,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'sav_goals_cnt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 0,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'invest_profit_amt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 999,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'invest_top_up_amt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 999,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'invest_turnover_amt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 999,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'loyalty_pro_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 499,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'se_days_cnt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 9,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'loyalty_travel_sum_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 999,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'sp_projects_cnt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 0,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'cnt_days_spend_1000',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 5,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'cnt_days_balance_1000',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 5,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'cnt_party_eq_spend',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 0,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'nights_cnt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 0,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'loyalty_pemium_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 1999,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'jun_sav_top_up_amt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 100,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'se_receipt_cnt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 9,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'top_ticker',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'loyalty_accrual_amt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 499,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'bk_spend_amt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 49999,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'mango_cnt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 0,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'tfood_fav_item',
    rules: [
      {
        name: StatisticItemValidationType.BlackListString,
        value: TFOOD_FAV_ITEM_BLACK_LIST,
      },
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'tfood_fav_item_cnt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 1,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'retrograde_perc',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: -90,
      },
      {
        name: StatisticItemValidationType.LessThanValue,
        value: 500,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'top_top_up_amt',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 999,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'top_top_up_dt',
    rules: [
      {
        name: StatisticItemValidationType.DayMonthDate,
        value: true,
      },
    ],
  },
];
